export const YOUTUBE_VIDEO_FORMAT: string = 'VIDEO/YOUTUBE';
export const VIMEO_VIDEO_FORMAT: string = 'VIDEO/VIMEO';
export const IMAGE_FORMAT: string = 'IMAGE';
export const IMAGE_FORMAT_LOWERCASE: string = 'image';
export const VIDEO_FORMAT_LOWERCASE: string = 'video';

export type DcpMediaType = 'GALLERY' | 'ICON';
export type DcpMediaQuality = 'low' | 'high' | 'standard';

export interface DcpMedia {
  type: DcpMediaType;
  url: string;
  title: string;
  altText: string;
  format: string;
  imageClassification: object;
  videoClassification: object;
  quality?: DcpMediaQuality;
}
